import { Component, OnInit } from '@angular/core';
import { DevExtremeModule } from 'devextreme-angular';
import { AppInformationService, AuthService, CdrUnitOfWork } from 'src/app/core/core.module';
import { RecurringJob } from 'src/app/core/model/recurring-job';
import { confirm, alert } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-recurring-jobs',
    templateUrl: './recurring-jobs.component.html',
    styleUrls: ['./recurring-jobs.component.scss'],
    standalone: true,
    imports: [DevExtremeModule]
})
export class RecurringJobsComponent implements OnInit {
    recurringJobs: RecurringJob[];

    constructor(private uow: CdrUnitOfWork, private appInfo: AppInformationService, private auth: AuthService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.recurringJobs = await this.uow.recurringJobs.whereActive('startDate', 'jobs.rental.customer');
        this.recurringJobs.forEach(x => {
            x.calcUncompletedJobs();
            x.calcCompletedJobs();
            const job = x.jobs?.[0];
            if (job) {
                (x as any).customer = job?.rental?.customer.displayName;
                (x as any).address = job.address1 + job.city;
            }
        });
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons'
            },
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    }
                }
            },
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    }
                }
            }
        );
    }

    async delete(recurringJob: RecurringJob) {
        const result = await confirm(
            `Are you sure you want to delete the selected recurrence? This will delete its ${recurringJob.uncompletedJobs} uncompleted jobs.`,
            `${this.appInfo.company}`
        );
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        recurringJob.deleted = new Date();
        recurringJob.deletedBy = this.auth.userValue.userName;
        recurringJob.jobs
            .filter(x => !x.deleted && !x.completed)
            .forEach(x => {
                x.deleted = new Date();
            });
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
}
